var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { class: _vm.isPath ? "homeFooter" : "" }, [
    _vm.isPath
      ? _c("div", { staticClass: "authorize full_layout" }, [
          _c("h3", { staticClass: "allTitle" }, [
            _vm._v(_vm._s(_vm.$t("Authorized")))
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "authorizeDiv",
            attrs: { src: require("../../static/images/footer_empower.png") }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "copytext" }, [
      _vm._v(
        "\n    Daka Hongkong Culture Development Limited © Daka 2012-" +
          _vm._s(_vm.year) +
          " \n    "
      ),
      _c(
        "div",
        [
          _c("router-link", { attrs: { to: { path: "/privacyagreement" } } }, [
            _vm._v(_vm._s(_vm.$t("PrivacyPolicy")))
          ]),
          _vm._v(" | \n      "),
          _c("router-link", { attrs: { to: { path: "/useragreement" } } }, [
            _vm._v(_vm._s(_vm.$t("UserAgreement")))
          ]),
          _vm._v(" | \n      "),
          _c("span", [_vm._v("ICP证：沪ICP备2022031093号-1")])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c4d8baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c4d8baa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = null
// module chunks = 